export default __webpack_public_path__ + "static/VD_progress3-8fe8ff874eab408a88a131c7b2dcab8b.jpg";